<template>
  <header class="main-header relative z-20" data-testid="main-header">
      <mobile-header :has-logo="displayLogo">
        <a href="/" v-if="displayLogo" data-testid="main-header-logo-mobile">
          <img src="../assets/logo.avif" width="96" alt="">
        </a>
      </mobile-header>
      <div v-if="isRoom" class="max-md:hidden" data-testid="main-header-room-logo-container">
        <a href="javascript:;" class="main-header__logo" @click="closeConference" v-if="displayLogo" data-testid="main-header-logo-room">
          <img src="../assets/logo.avif" width="114" alt="" data-testid="main-header-logo-image">
        </a>
      </div>
      <div v-else class="max-md:hidden" data-testid="main-header-default-logo-container">
        <a href="/" class="main-header__logo" v-if="displayLogo" data-testid="main-header-logo-default">
          <img src="../assets/logo.avif" width="167" alt="" data-testid="main-header-logo-image">
        </a>
      </div>
      <nav class="flex justify-end items-center ml-auto max-md:hidden" v-if="!$route.meta.tpl" data-testid="main-header-navigation">
        <router-link to="/faq" class="nav-link lg:inline-flex text-white/75 text-19 hover:text-white/89"
        data-testid="faq-title">{{ $t('about_forum') !== 'about_forum' ? $t('about_forum') : 'About Forum'}}</router-link>
        <router-link to="/plans" class="nav-link lg:inline-flex text-white/75 text-19 hover:text-white/89"
        data-testid="pricing-title">{{ $t('pricing_title') }}</router-link>
        <a @click="openTermsPopup"  v-if="!authorized" class="cursor-pointer nav-link text-white/75 text-19 hover:text-white/89 whitespace-nowrap" data-testid="signin-title">{{ $t('signin_title')}}<span class="hidden lg:inline-block">/{{ $t('register_title')}}</span></a>
        <a @click="openAccountPopup"  v-else class="nav-link text-white/75 text-19 hover:text-white/89 cursor-pointer" data-testid="account-title">
          <img src="@/assets/icons/account-icon.svg" alt="Account" class="h-[20px] w-[20px] mr-1 inline-block align-middle" data-testid="account-icon">
          {{ $t('profile_title')}}
        </a>
      </nav>

      <div id="#header"></div>
      <a href="javascript:;" v-if="$route.meta.tpl && $route.meta.tpl == 'conference'" @click="closeConference" class="icon-btn conference-close" data-testid="conference-close-button">
        <img src="@/assets/icons/xmark.svg" alt="Close" data-testid="conference-close-icon">
      </a>
  </header>
</template>

<script>
// @ is an alias to /src
import { mapState } from 'vuex';
import emitter from "@/services/emitter.service";
import MobileHeader from "@/components/MobileHeader.vue";


export default {
  name: 'MainHeader',
  components: {
    MobileHeader,
  },
  methods: {
    closeConference() {
      emitter.emit('open-leave-session-modal')
    },
    openBeacon() {
      window.Beacon('open');
    },
    openTermsPopup() {
      emitter.emit('open-terms-agreement-modal');
    },
    openAccountPopup() {
      emitter.emit('open-account-popup');
    }
  },
  computed: {
     ...mapState('auth', ['token', 'authorized']),
     ...mapState('event', ['event', 'is_room_owner']),
    displayLogo() {
      return this.$route.name != 'home'
    },
    isRoom(){
      return this.$route.name == 'room'
    }
  },
  mounted() {
    emitter.on('close-conference', () => {
      this.closeConference();
    });
  },
  beforeUnmount() {
    emitter.off('close-conference', this.closeConference);
  }
}
</script>

<style lang="scss">
  .main-header {
    padding: 33px 30px 0;
    display: flex;
    justify-content: space-between;

    &__logo {  
      position: relative;
      z-index: 10;
    }
  }

  .conference-close {
    z-index: 6;
  }
</style>
